
import Socials from '~/components/common/Socials.vue';
import { ymGoalCheck } from '~/helpers/ym_helper';

export default {

  data() {
    return {
      phoneNumber: '',
    };
  },
  components: { Socials },
  props: {
    menu: {
      type: Array,
      default: () => [],
    },

    vars: {
      type: [Object, Array],
      default() {
        return [];
      },
    },

    appCfg: {
      type: Object,
      default() {
        return {};
      },
    },

  },
  computed: {
    currentYear() {
      return new Date().getUTCFullYear();
    },
    catalogList() {
      let catalog = [...this.menu];

      catalog = catalog.map((item, idx) => ({
        ...item,
        // items: (item.items || []).filter((t) => !!t.showInMenu),
        items: item.items,
      }));

      return catalog;
    },

    currentPhoneNumber() {
      return this.$store.state.currentPhone.currentPhone || '';
    },

    email() {
      return this.vars?.email || '';
    },

    address() {
      return this.vars?.['адрес'] || '';
    },
  },
  methods: {
    emailHandler({ target }) {
      if (process.client) {
        if (window.screen.width > 1023) {
          navigator.clipboard.writeText(target.innerText);
          this.$toast.success('Email скопирован');
        } else {
          window.location.href = `mailto:${this.email}`;
        }
      }
    },
    openCallbackModal() {
      this.$store.commit('pop-up-back-call/openCallbackPopup', {
        yandexMetriks: {
          ymGoal: 'zapros_zvonok_sent',
          ymNumber: process.env.yandexMetriks,
        },
      });

      ymGoalCheck({
        ymGoal: 'zapros_zvonok_form',
        ymNumber: process.env.yandexMetriks,
      });
    },
  },
};
